module.exports = __webpack_public_path__ + "static/media/condes_mobile.4c817db0.jpg";